// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import FancyboxController from "./fancybox_controller"
application.register("fancybox", FancyboxController)

import InjuriesController from "./injuries_controller" 
application.register("injuries", InjuriesController)

import LegendaryRegimentsController from "./legendary_regiments_controller"
application.register("legendary-regiments", LegendaryRegimentsController)

import HeaderController from "./header_controller"
application.register("header", HeaderController)
